import {useApp} from "../app.context";

interface AssetImageProps {
    id: string;
    size?: number;
    background?: string;
    onClick?(): void;
    style?: React.CSSProperties;
}

// Display-only image element. Deliberately has NO upload path: clicking an
// image never opens a file dialog. Image assignment goes through the
// ImagePicker modal (pack slots via the ImagePack popup, metadata icons via
// MetadataElement); raw file uploads exist only inside the picker's
// "Upload new" button and the Images/Sounds tabs' explicit buttons.
function AssetImage(props: AssetImageProps) {
    const {getImageUrl} = useApp();

    return (
        <div style={{
            position: 'relative',
            borderRadius: 5,
            width: props.size ?? 50,
            height: props.size ?? 50,
            backgroundColor: props.background ?? 'black',
            ...props.style
        }}
             onClick={props.onClick}
        >
            <img alt={''} style={{
                borderRadius: 5,
                width: '100%',
                height: '100%'}}
                 src={getImageUrl(props.id)}
            />
        </div>
    )
}

export default AssetImage;
